import apiService from "./apiService";
import AppConstants from "../appConstants";

class UserHeaderService {
    getAllUserHeader(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_USER_HEADER, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getUserHeaderDetails(id, params) {
        return new Promise((resolve, reject) => {
            apiService.get(`${AppConstants.URL_USER_HEADER}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    registerUserHeader(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_USER_HEADER, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    deleteUserHeader(id, params) {
        return new Promise((resolve, reject) => {
            apiService.delete(`${AppConstants.URL_USER_HEADER}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    report(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadPublicFile(AppConstants.URL_USER_HEADER_REPORT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    
    // =====================================================================
    
}

export default new UserHeaderService();
